import React, { useState, useEffect } from 'react';
import { getProducts } from '../services/api';
import { useCart } from '../context/CartContext';

function formatRupiah(n) { return 'Rp ' + n.toLocaleString('id-ID'); }

export default function HomePage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [added, setAdded] = useState({});
  const { addItem } = useCart();

  const fetchProducts = async (s = '') => {
    setLoading(true); setError('');
    try {
      const res = await getProducts(s ? { search: s } : {});
      const data = res?.data?.data;
      setProducts(Array.isArray(data) ? data : []);
    } catch (e) {
      setProducts([]);
      setError('Gagal memuat produk. Pastikan REACT_APP_API_URL sudah diset dengan benar.');
    }
    setLoading(false);
  };

  useEffect(() => { fetchProducts(); }, []);

  const handleAdd = (product) => {
    addItem(product);
    setAdded(prev => ({ ...prev, [product._id]: true }));
    setTimeout(() => setAdded(prev => ({ ...prev, [product._id]: false })), 1500);
  };

  return (
    <div className="page-enter">
      {/* Hero */}
      <div className="hero">
        <div className="hero-eyebrow">
          <span className="dot"></span>
          Toko Online
        </div>
        <div className="hero-title">
          <span className="ht1">Belanja Mudah,</span><br />
          <span className="ht2">Bayar Instan QRIS</span>
        </div>
        <div className="hero-sub">Temukan produk terbaik kami dan bayar dengan scan QR kapanpun.</div>
      </div>

      {/* Search */}
      <form className="search-wrap" onSubmit={e => { e.preventDefault(); fetchProducts(search); }}>
        <input className="form-control" placeholder="🔍  Cari produk..." value={search} onChange={e => setSearch(e.target.value)} />
        <button type="submit" className="btn btn-ghost">Cari</button>
        {search && (
          <button type="button" className="btn btn-secondary" onClick={() => { setSearch(''); fetchProducts(); }}>✕</button>
        )}
      </form>

      {error && <div className="alert alert-error">⚠️ {error}</div>}

      {loading ? (
        <div className="loading"><div className="spinner"></div>Memuat produk...</div>
      ) : products.length === 0 && !error ? (
        <div className="empty-state">
          <span className="empty-icon">📭</span>
          <p>Belum ada produk. Tambahkan via Bot Telegram.</p>
        </div>
      ) : (
        <>
          <div className="sec-title">// produk tersedia — {products.length} item</div>
          <div className="product-grid">
            {products.map((product, i) => (
              <div key={product._id} className="card" style={{ animationDelay: `${i * 0.06}s` }}>

                {/* ── Baris Atas: Thumbnail | Info ── */}
                <div className="card-top">

                  {/* Kiri: Thumbnail */}
                  <div className="product-thumb">
                    {product.image
                      ? <img src={product.image} alt={product.name} onError={e => e.target.style.display='none'} />
                      : <div className="product-thumb-placeholder">🛍️</div>
                    }
                  </div>

                  {/* Kanan: Kategori + Nama + Deskripsi */}
                  <div className="product-info">
                    {product.category && (
                      <div className="product-cat">{product.category}</div>
                    )}
                    <div className="product-name">{product.name}</div>
                    {product.description && (
                      <div className="product-desc">{product.description}</div>
                    )}
                  </div>
                </div>

                {/* ── Bawah: Harga + Stok + Tombol ── */}
                <div className="card-bottom">
                  <div className="card-bottom-row">
                    <div className="product-price">{formatRupiah(product.price)}</div>
                    <div className={`product-stock ${product.stock <= 5 ? 'low' : ''}`}>
                      {product.stock} stok
                    </div>
                  </div>
                  <button
                    className={`btn ${added[product._id] ? 'btn-success' : 'btn-primary'}`}
                    onClick={() => handleAdd(product)}
                    disabled={product.stock === 0}
                  >
                    {product.stock === 0 ? '❌ Stok Habis' : added[product._id] ? '✅ Ditambahkan!' : '+ Keranjang'}
                  </button>
                </div>

              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
